import React, { useState } from "react"
import { TimelineTemplateProps } from "components/Transactional/Performance/components/Timeline/interfaces"
import {
	DEFAULT_TIMELINE_RESPONSE,
	METRIC,
	NON_OPTION,
	SELECTED_METRIC,
} from "components/Transactional/Performance/components/Timeline/constants"
import { useGetTimeLineBenchmark } from "components/Transactional/Performance/hooks/useGetTimeLineBenchmark"
import {
	BenchmarkTimelineData,
	RequestParameters,
} from "components/Transactional/Performance/interfaces"
import TimelineContainer from "../Container/TimelineContainer"
import { WEEKLY_INTERVAL } from "components/Shared/Timeline/constants"
import { mapData } from "components/Transactional/Performance/components/Timeline/utils"
import { mapGlobalFilters } from "components/Shared/GlobalFilter/utils"
import { globalFiltersMapBackendConfig } from "components/Shared/GlobalFilter/constants"

const TimelineDoubleChartTemplate = (props: TimelineTemplateProps) => {
	const { timelineMetric, filters, period, dates } = props
	const [interval, setInterval] = React.useState(WEEKLY_INTERVAL)
	const [otherMetric, setOtherMetric] = useState<string>(NON_OPTION)

	const benchmarkGlobalFilters = mapGlobalFilters(
		filters,
		globalFiltersMapBackendConfig
	)

	const {
		timelineData = DEFAULT_TIMELINE_RESPONSE,
		isPendingRequest,
		error,
		isError,
		refetch,
	} = useGetTimeLineBenchmark({
		...benchmarkGlobalFilters,
		...dates,
		period,
		interval,
		selectedMetric: SELECTED_METRIC[timelineMetric],
		metricName: METRIC[timelineMetric],
	} as RequestParameters)

	const data = {
		data: timelineData.commercialBenchmarkTimeline?.data?.map(
			(item: BenchmarkTimelineData) => ({
				interval: item.interval,
				primaryTrack: item.currentAmount,
				secondaryTrack: item.previousAmount,
				detailTrack: item.percentageGrowth,
				primaryDate: item.currentDate,
				secondaryDate: item.previousDate,
			})
		),
	}

	const {
		timelineData: otherData = DEFAULT_TIMELINE_RESPONSE,
		isPendingRequest: otherIsFetching,
		isError: isErrorOther,
		refetch: refetchOther,
	} = useGetTimeLineBenchmark({
		...benchmarkGlobalFilters,
		...dates,
		period,
		interval,
		selectedMetric: SELECTED_METRIC[otherMetric],
		metricName: METRIC[otherMetric],
	} as RequestParameters)

	const formattedData = mapData(
		data?.data,
		otherData.commercialBenchmarkTimeline?.data
	)

	return (
		<TimelineContainer
			{...props}
			interval={interval}
			setInterval={setInterval}
			otherMetric={otherMetric}
			setOtherMetric={setOtherMetric}
			timelineData={formattedData}
			isPendingRequest={isPendingRequest}
			error={error}
			isError={isError}
			refetch={refetch}
			otherIsFetching={otherIsFetching}
			isErrorOther={isErrorOther}
			refetchOther={refetchOther}
			secondaryStrokeDasharray={"5 5"}
		/>
	)
}

export default TimelineDoubleChartTemplate
